import { BeekSessionStatus, getSessionStatus } from 'src/utils/user';
import {
  GetServerSideProps,
  GetServerSidePropsContext,
  GetServerSidePropsResult,
} from 'next';
import { NextArticlePath, fetchAllSlugs } from 'src/api/article/dataArticle';
import { deleteLoginTokenSucceed } from 'src/app/auth/cookies';
import { getLoginTokenSucceed } from 'src/app/auth/cookiesServerSide';
import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import BranchScript from 'src/components/BranchScript/BranchScript';
import Header from 'src/components/LandingPage/Header';
import LandingPageLayout from 'src/components/LandingPage/Layout';
import toast from 'react-hot-toast';

type LandingPageProps = {
  articleSlugs: NextArticlePath[];
  messages: {
    [index: string]: string;
  };
  sessionStatus: BeekSessionStatus;
  loginTokenError: boolean;
};

const IndexPage = (props: LandingPageProps): JSX.Element => {
  const { articleSlugs, sessionStatus, loginTokenError } = props;

  const t = useTranslations('auth');

  useEffect(() => {
    if (loginTokenError) {
      toast.error(t('errors.notAuthorizedToken'));
      deleteLoginTokenSucceed();
    }
  });

  return (
    <>
      <Header />
      <BranchScript />
      <LandingPageLayout
        articles={articleSlugs}
        sessionStatus={sessionStatus}
      />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
): Promise<GetServerSidePropsResult<LandingPageProps>> => {
  const sessionStatus = await getSessionStatus(context);
  if (sessionStatus === BeekSessionStatus.LoggedInWithSubscription) {
    return {
      redirect: {
        destination: '/home',
        permanent: false,
      },
    };
  }

  let data: NextArticlePath[] = await fetchAllSlugs();
  if (!data) {
    data = [];
  }

  const loginTokenSucceed = getLoginTokenSucceed(context);
  let loginTokenError = false;
  if (loginTokenSucceed && loginTokenSucceed === 'false')
    loginTokenError = true;

  return {
    props: {
      articleSlugs: data,
      messages: {
        ...require(`src/messages/landing/${context.locale}.json`),
        ...require(`src/messages/article/${context.locale}.json`),
        ...require(`src/messages/auth/${context.locale}.json`),
      },
      sessionStatus,
      loginTokenError,
    },
  };
};

export default IndexPage;
